import React from 'react';
import getLatAndLong from '../../../api/getLatAndLong';
import getWeatherInfo from '../../../api/getWeatherInfo';
import './Weather.css';

export default class Weather extends React.Component {
  state = {
    picUrl: "//cdn.weatherapi.com/weather/64x64/night/122.png",
    degree: "8°C",
    text: "Overcast"
  }

  async getWeather() {
    const geoInfo = await getLatAndLong();
    const weatherInfo = await getWeatherInfo(geoInfo);
    
    this.setState({
      picUrl: weatherInfo.current.condition.icon,
      degree: weatherInfo.current.temp_c + "°C",
      text: weatherInfo.current.condition.text
    });  
  }

  componentDidMount() {
    this.getWeather();
  }

  componentWillUnmount() {
    this.setState = () => {
      return;
    }
  }

  render() {
    const {picUrl, degree, text} = this.state;

    return (
      <React.Fragment>
        <h5>Weather</h5>
        <div className="weather-content">
          <img src={picUrl} alt="wheatherPic" />
          <div className="weather-content-text">
            <div>{degree}</div>
            <div>{text}</div>
          </div>
        </div>
      </React.Fragment>   
    )
  }
}